import React, { useState, useEffect } from "react";
import { useApiFetch } from "../utils/apiFetch";
import { useGlobal } from "../context/ContenedorGlobal";

function InputSelectGenerico({
    idSeleccionado,
    setIdSeleccionado,
    label = "Etiqueta del input",
    apiUrl,                 // Endpoint de la API , solo el nombre de la api
    valueField = "id",      // Campo clave
    displayField = "nombre",// Campo visible 
    readOnly = false,
    showDefaultOption = true,
    defaultOptionText = "Seleccione una opción",
    onChange = null,
    dataField = null
}) {
    const apiFetch = useApiFetch();
    const [opciones, setOpciones] = useState([]);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(true);
    const { logout } = useGlobal();

    useEffect(() => {
        const cargarOpciones = async () => {
            setLoading(true);
            try {
                const data = await apiFetch(apiUrl, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" }
                }, logout);

                let lista = [];

                if (Array.isArray(data)) {
                    lista = data;
                } else if (dataField && Array.isArray(data[dataField])) {
                    lista = data[dataField];
                } else if (typeof data === "object" && data !== null) {
                    for (const key in data) {
                        if (Array.isArray(data[key])) {
                            lista = data[key];
                            break;
                        }
                    }
                }

                if (lista.length > 0) {
                    setOpciones(lista);
                    setError("");
                } else {
                    setError(data.message || "\u274C No se pudieron cargar las opciones.");
                }
            } catch {
                setError("\u274C Error de conexión al cargar opciones.");
            } finally {
                setLoading(false);
            }
        };

        cargarOpciones();
    }, [apiUrl, dataField]);

    const handleChange = (e) => {
        const newValue = e.target.value;
        setIdSeleccionado(newValue);
        if (onChange) onChange(newValue);
    };

    return (
        <div className="form-group">
            <label>{label}</label>

            {readOnly ? (
                <p className="readonly-text">
                    {typeof displayField === "function"
                        ? displayField(opciones.find(o => String(o[valueField]) === String(idSeleccionado)) || {})
                        : opciones.find(o => String(o[valueField]) === String(idSeleccionado))?.[displayField] || "—"}
                </p>
            ) : (
                <select
                    className="input"
                    value={idSeleccionado || ""}
                    onChange={handleChange}
                    disabled={loading || readOnly}
                >
                    {showDefaultOption && (
                        <option value="" disabled>{defaultOptionText}</option>
                    )}
                    {opciones.map((o) => (
                        <option key={o[valueField]} value={o[valueField]}>
                            {typeof displayField === "function"
                                ? displayField(o)
                                : o[displayField]}
                        </option>
                    ))}
                </select>
            )}

            {loading && <div className="loading">Cargando opciones...</div>}
            {error && <div className="error">{error}</div>}
        </div>
    );
}

export default InputSelectGenerico;